module.exports = __webpack_public_path__ + "assets/img/omron_hem7124.3c2be9bc.png";